import React from 'react';
import './PC.css';
import Bell from '../../img/Speakers_temporary/Bell.png'
import Bowman from '../../img/Speakers_temporary/Bowman.png'
import CertiK from '../../img/Speakers_temporary/CertiK.png'
import ConsenSys from '../../img/Speakers_temporary/ConsenSys.png'
import deBridge from '../../img/Speakers_temporary/deBridge.png'
import DeliveryHero from '../../img/Speakers_temporary/DeliveryHero.png'
import FrontRow from '../../img/Speakers_temporary/FrontRow.png'
import Huisman from '../../img/Speakers_temporary/Huisman.png'
import Infura from '../../img/Speakers_temporary/Infura.png'
import Kashyap from '../../img/Speakers_temporary/Kashyap.png'
import Liuetad from '../../img/Speakers_temporary/Liuetad.png'
import NEAR from '../../img/Speakers_temporary/NEAR.png'
import Polkadot from '../../img/Speakers_temporary/Polkadot.png'
import Rarible from '../../img/Speakers_temporary/Rarible.png'
import Ruaro from '../../img/Speakers_temporary/Ruaro.png'
import Salman from '../../img/Speakers_temporary/Salman.png'
import Salnikov from '../../img/Speakers_temporary/Salnikov.png'
import Singh from '../../img/Speakers_temporary/Singh.png'
import Smirnov from '../../img/Speakers_temporary/Smirnov.png'
import StarkWare from '../../img/Speakers_temporary/StarkWare.png'
import Tiu from '../../img/Speakers_temporary/Tiu.png'
import Türk from '../../img/Speakers_temporary/Türk.png'
import Wade from '../../img/Speakers_temporary/Wade.png'
import Web3Foundation from '../../img/Speakers_temporary/Web3 Foundation.png'
import Yurtaev from '../../img/Speakers_temporary/Yurtaev.png'
import Zerion from '../../img/Speakers_temporary/Zerion.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Türk,
          name: 'Enes Türk',
          position: 'Ambassador',
          ln: 'https://www.linkedin.com/in/enesturkcom/',
          logo: Polkadot,
        },
        {
          photo: Tiu,
          name: 'Vincent Tiu',
          position: 'Software Engineer',
          ln: 'https://www.linkedin.com/in/vincetiu8/',
          logo: Infura,
        },
        {
          photo: Bell,
          name: 'Tjomb Bell',
          position: 'Software Engineer',
          ln: 'https://www.linkedin.com/in/tjomb-bell-new/',
          logo: ConsenSys,
        },
        {
          photo: Ruaro,
          name: 'Neil Ruaro',
          position: 'Software Engineer',
          ln: 'https://www.linkedin.com/in/eruaro/',
          logo: CertiK,
        },
        {
          photo: Wade,
          name: 'Chris Wade',
          position: 'Technologist',
          ln: 'https://www.linkedin.com/in/currentintech/',
        },
      ],
      pcHide: [
        {
          photo: Huisman,
          name: 'Dennis Oliver Huisman',
          position: 'DevRel Engineer',
          ln: 'https://www.linkedin.com/in/dennisoliverhuisman/',
          logo: NEAR,
        },
        {
          photo: Liuetad,
          name: 'Henri Liuetad',
          position: 'Developer Advocate',
          ln: 'https://www.linkedin.com/in/henri-liuetad-2156a142/',
          logo: StarkWare,
        },
        {
          photo: Bowman,
          name: 'Idris Bowman',
          position: 'Backend Engineer',
          ln: 'https://www.linkedin.com/in/idris-bowman/',
          logo: ConsenSys,
        },
        {
          photo: Singh,
          name: 'Vijay Pratap Singh',
          position: 'Senior Software Engineer',
          ln: 'https://www.linkedin.com/in/vijay-pratapsingh/',
          logo: DeliveryHero,
        },
        {
          photo: Salman,
          name: 'Danny Salman',
          position: 'Technical Educator',
          ln: 'https://www.linkedin.com/in/dannysalman/',
          logo: Web3Foundation,
        }, {
          photo: Kashyap,
          name: 'Sameer Kashyap',
          position: 'Software Engineer',
          ln: 'https://www.linkedin.com/in/sameer-kashyap-083a89184/',
          logo: FrontRow,
        },
        {
          photo: Salnikov,
          name: 'Alexander Salnikov',
          position: 'CSO',
          tw: 'https://twitter.com/insider0x',
          logo: Rarible,
        },
        {
          photo: Yurtaev,
          name: 'Evgeny Yurtaev',
          position: 'Cofounder',
          tw: 'https://twitter.com/evgeth_',
          logo: Zerion,
        },
        {
          photo: Smirnov,
          name: 'Alex Smirnov',
          position: 'CEO',
          tw: 'https://mobile.twitter.com/alexsmirnov__',
          logo: deBridge,
        },
      ],
      hide: true,
    }
    this.togglePC = this.togglePC.bind(this);
  }

  togglePC() {
    this.setState({ hide: !this.state.hide });
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="pc_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel='noreferrer' href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel='noreferrer' href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel='noreferrer' href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel='noreferrer' href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel='noreferrer' href={item.website}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc" id='pc'>
        <div className='container team_wrap'>
          <h3>Program committee</h3>
          <div className="pc_block">
            {this.state.pc.map((item, i) => this.renderPC(item, i))}
            {!this.state.hide && this.state.pcHide.map((item, i) => this.renderPC(item, i))}
          </div>
          <button className='pc_btn' onClick={this.togglePC}>{this.state.hide ? 'Show more' : 'Hide'}</button>
        </div>
      </div>
    )
  }
}